import React from "react";

import styles from "./styles.modules.scss";

export const MegaCrabBannerView = () => (
    <div className={`${styles.banner}`}>
        <img className={styles["megacrab-picture"]} src="images/megacrab.png" />

        <h2>Megacrab videos</h2>

        <img className={styles["megacrab-bg"]} src="images/megacrab-bg.jpg" />
    </div>
);
